<div class="upload-wrapper" fxLayout="column" fxLayoutAlign="center">
	<div
		class="upload-drop"
		(drop)="handleDrop($event)"
		(dragover)="handleDrag($event)"
		(dragleave)="handleDrag($event)"
		[ngClass]="{ 'drag-over': isOver }"
	>
		<div
			class="upload-drop-indicator"
			*ngIf="(isUploading$ | async) === false && (isUploadError$ | async) === false && !files.length"
		>
			<div class="upload-drop-title" i18n="@@UploadFileDragHere">Drag file here</div>
			<g-icon [icon]="icons.faFile" size="4x" class="upload-drop-icon" />
		</div>
		<div
			class="upload-failed"
			*ngIf="!multiple && (isUploading$ | async) === false && (isUploadError$ | async)"
		>
			<div class="upload-drop-title" i18n="@@UploadFileFailed">Upload failed</div>
			<g-icon [icon]="icons.faTriangleExclamation" size="4x" class="upload-drop-failed" />
		</div>
		<g-icon
			*ngIf="!multiple && (isUploading$ | async)"
			[icon]="icons.faSpinner"
			size="4x"
			pulse
			fixedWidth
			class="upload-drop-spinner"
		/>

		<div class="upload-queue">
			<div
				class="upload-file"
				*ngFor="let file of files"
				[ngClass]="{ 'upload-file-failed': file.status === statusType.Error }"
				fxLayout="row"
				fxLayoutGap="1rem"
			>
				<a
					[attr.href]="file.status === statusType.Success ? file.fileUrl : '#'"
					fxLayout="row"
					download
					fxFlex
				>
					<div class="file-info" fxFlex>
						<span class="filename">{{ file.filename }}</span>
					</div>
					@if (file.status) {
						<g-icon
							[icon]="statusIndicator[file.status].icon"
							[ngClass]="statusIndicator[file.status].class"
							[title]="statusIndicator[file.status].description"
							[pulse]="!!statusIndicator[file.status].pulse"
						/>
					}
				</a>
				<div class="filesize">{{ file.fileSize }}</div>
				<div class="file-actions" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="end">
					<g-icon
						[icon]="icons.faTrashCan"
						class="clear-input"
						i18n-title
						title="Clear file"
						role="button"
						(click)="clearInputFile(file)"
					/>
				</div>
			</div>
		</div>
	</div>
	<div class="upload-button">
		<button class="btn btn-secondary" (click)="chooseFile($event)">
			<span class="upload-file-button" i18n="@@UploadFile">Upload file</span>
			<g-icon [icon]="icons.faFile" fixedWidth class="upload-file-button" />
		</button>
		<input
			#fileInput
			class="upload-button-input"
			type="file"
			[accept]="acceptedFiletypes"
			[multiple]="multiple"
			(click)="$any($event.target).value = null"
			(change)="handleFileInput($event)"
		/>
	</div>
</div>
